/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_BuildInputs */

const id_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const ms_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaan`)
};

const da_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const de_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const en_us2_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const es_es2_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación`)
};

const es_mx2_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación`)
};

const fil_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const fr_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilation`)
};

const it_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const hu_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const nl_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const no_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const pl_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompilacja`)
};

const pt_br2_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build`)
};

const pt_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilação`)
};

const ro_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilare`)
};

const fi_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koontiversio`)
};

const sv_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bygge`)
};

const vi_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản dựng`)
};

const tr_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapı`)
};

const cs_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sestavení`)
};

const bg_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компилация`)
};

const ru_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сборка`)
};

const uk_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Збірка`)
};

const ar_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنية`)
};

const hi_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिल्ड`)
};

const th_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บิลด์`)
};

const ja_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビルド`)
};

const zh_cn2_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`构建版本`)
};

const zh_hant1_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建置版本`)
};

const ko_builds_build = /** @type {(inputs: Builds_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빌드`)
};

/**
* | output |
* | --- |
* | "Build" |
*
* @param {Builds_BuildInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_build = /** @type {((inputs?: Builds_BuildInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_BuildInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_build(inputs)
	if (locale === "ms") return ms_builds_build(inputs)
	if (locale === "da") return da_builds_build(inputs)
	if (locale === "de") return de_builds_build(inputs)
	if (locale === "en-US") return en_us2_builds_build(inputs)
	if (locale === "es-ES") return es_es2_builds_build(inputs)
	if (locale === "es-MX") return es_mx2_builds_build(inputs)
	if (locale === "fil") return fil_builds_build(inputs)
	if (locale === "fr") return fr_builds_build(inputs)
	if (locale === "it") return it_builds_build(inputs)
	if (locale === "hu") return hu_builds_build(inputs)
	if (locale === "nl") return nl_builds_build(inputs)
	if (locale === "no") return no_builds_build(inputs)
	if (locale === "pl") return pl_builds_build(inputs)
	if (locale === "pt-BR") return pt_br2_builds_build(inputs)
	if (locale === "pt") return pt_builds_build(inputs)
	if (locale === "ro") return ro_builds_build(inputs)
	if (locale === "fi") return fi_builds_build(inputs)
	if (locale === "sv") return sv_builds_build(inputs)
	if (locale === "vi") return vi_builds_build(inputs)
	if (locale === "tr") return tr_builds_build(inputs)
	if (locale === "cs") return cs_builds_build(inputs)
	if (locale === "bg") return bg_builds_build(inputs)
	if (locale === "ru") return ru_builds_build(inputs)
	if (locale === "uk") return uk_builds_build(inputs)
	if (locale === "ar") return ar_builds_build(inputs)
	if (locale === "hi") return hi_builds_build(inputs)
	if (locale === "th") return th_builds_build(inputs)
	if (locale === "ja") return ja_builds_build(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_build(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_build(inputs)
	return ko_builds_build(inputs)
});
export { builds_build as "builds.build" }